module.exports = [
	{
		"geography": "China",
		"income": 7028981.4,
		"household": 15294.4,
		"growth": 8
	},
	{
		"geography": "Shanghai",
		"income": 283402.4,
		"household": 26673.7,
		"growth": 7
	},
	{
		"geography": "Beijing",
		"income": 247705,
		"household": 26398.8,
		"growth": 8.6
	},
	{
		"geography": "Guangzhou",
		"income": 134806.3,
		"household": 24013.7,
		"growth": 7.7
	},
	{
		"geography": "Shenzhen",
		"income": 116486.9,
		"household": 21299.7,
		"growth": 7.9
	},
	{
		"geography": "Tianjin",
		"income": 114425.9,
		"household": 19209.7,
		"growth": 9.9
	},
	{
		"geography": "Nanjing",
		"income": 83891.8,
		"household": 25668.8,
		"growth": 7.7
	},
	{
		"geography": "Dongguan",
		"income": 74742.4,
		"household": 16763.2,
		"growth": 6.2
	},
	{
		"geography": "Foshan",
		"income": 71817.3,
		"household": 22416.1,
		"growth": 8.9
	},
	{
		"geography": "Wuhan",
		"income": 67007.3,
		"household": 17436,
		"growth": 9
	},
	{
		"geography": "Suzhou",
		"income": 64812.3,
		"household": 26140.7,
		"growth": 8.7
	},
	{
		"geography": "Hangzhou",
		"income": 64594.4,
		"household": 23207.2,
		"growth": 6.3
	},
	{
		"geography": "Chengdu",
		"income": 56015.6,
		"household": 16603,
		"growth": 9.8
	},
	{
		"geography": "Shenyang",
		"income": 45998.2,
		"household": 17196.8,
		"growth": 7.6
	},
	{
		"geography": "Xi'an",
		"income": 44329.6,
		"household": 17748.4,
		"growth": 8.7
	},
	{
		"geography": "Xiamen",
		"income": 44000.4,
		"household": 19069.1,
		"growth": 12.5
	},
	{
		"geography": "Chongqing",
		"income": 41729.1,
		"household": 12174.2,
		"growth": 11.1
	},
	{
		"geography": "Harbin",
		"income": 38898.6,
		"household": 16649.4,
		"growth": 8.5
	},
	{
		"geography": "Wuxi",
		"income": 36862.2,
		"household": 23778.9,
		"growth": 8.2
	},
	{
		"geography": "Ningbo",
		"income": 36029.4,
		"household": 21808.1,
		"growth": 8.7
	},
	{
		"geography": "Qingdao",
		"income": 33824.7,
		"household": 17900,
		"growth": 8.2
	},
	{
		"geography": "Zhengzhou",
		"income": 33754.1,
		"household": 18182.7,
		"growth": 9.1
	},
	{
		"geography": "Jinan",
		"income": 33306.8,
		"household": 20251,
		"growth": 7.9
	},
	{
		"geography": "Changsha",
		"income": 32566.9,
		"household": 22874.7,
		"growth": 9.6
	},
	{
		"geography": "Shantou",
		"income": 30302.8,
		"household": 21593.2,
		"growth": 8.2
	},
	{
		"geography": "Changzhou",
		"income": 29017.8,
		"household": 21276.5,
		"growth": 8
	},
	{
		"geography": "Dalian",
		"income": 28918.3,
		"household": 15998.1,
		"growth": 8.2
	},
	{
		"geography": "Zhongshan",
		"income": 27062.3,
		"household": 19543.4,
		"growth": 7.6
	},
	{
		"geography": "Hefei",
		"income": 26982.8,
		"household": 15928.2,
		"growth": 12.7
	},
	{
		"geography": "Ürümqi",
		"income": 24368.1,
		"household": 14751.4,
		"growth": 11.1
	},
	{
		"geography": "Kunming",
		"income": 24328.7,
		"household": 16039.5,
		"growth": 10
	},
	{
		"geography": "Wenzhou",
		"income": 24115.1,
		"household": 17832.6,
		"growth": 8.8
	},
	{
		"geography": "Changchun",
		"income": 22835.6,
		"household": 14400.5,
		"growth": 8.8
	},
	{
		"geography": "Nanning",
		"income": 22396.4,
		"household": 13734.9,
		"growth": 11.7
	},
	{
		"geography": "Taiyuan",
		"income": 22155.1,
		"household": 15471.7,
		"growth": 7.3
	},
	{
		"geography": "Zibo",
		"income": 20113.9,
		"household": 16675.9,
		"growth": 7
	},
	{
		"geography": "Tangshan",
		"income": 18655.9,
		"household": 15617,
		"growth": 6.7
	},
	{
		"geography": "Nanchang",
		"income": 17706.4,
		"household": 22806.3,
		"growth": 8.5
	},
	{
		"geography": "Guiyang",
		"income": 17599.1,
		"household": 13912.4,
		"growth": 8.1
	},
	{
		"geography": "Baotou",
		"income": 17536.8,
		"household": 18984.1,
		"growth": 8.1
	},
	{
		"geography": "Fuzhou",
		"income": 17186.8,
		"household": 14215.8,
		"growth": 8.6
	},
	{
		"geography": "Huizhou",
		"income": 16013.5,
		"household": 16610.9,
		"growth": 10.5
	},
	{
		"geography": "Yantai",
		"income": 16001.9,
		"household": 16234,
		"growth": 8.8
	},
	{
		"geography": "Taizhou",
		"income": 15385.4,
		"household": 19242.4,
		"growth": 7.2
	},
	{
		"geography": "Lanzhou",
		"income": 15279.3,
		"household": 13827,
		"growth": 9.6
	},
	{
		"geography": "Hohhot",
		"income": 15131.8,
		"household": 16924,
		"growth": 9
	},
	{
		"geography": "Shijiazhuang",
		"income": 15025.8,
		"household": 15595.6,
		"growth": 9
	},
	{
		"geography": "Xuzhou",
		"income": 14484.1,
		"household": 14533.2,
		"growth": 7
	},
	{
		"geography": "Zhuhai",
		"income": 13508.8,
		"household": 20968.6,
		"growth": 7.9
	},
	{
		"geography": "Weifang",
		"income": 12989.1,
		"household": 16354.6,
		"growth": 10.5
	},
	{
		"geography": "Daqing",
		"income": 12613.2,
		"household": 19575.1,
		"growth": 9.2
	},
	{
		"geography": "Haikou",
		"income": 12352.8,
		"household": 16604.8,
		"growth": 8
	},
	{
		"geography": "Linyi",
		"income": 11968,
		"household": 13723.7,
		"growth": 9.1
	},
	{
		"geography": "Xiangfan",
		"income": 11082.7,
		"household": 14596,
		"growth": 9
	},
	{
		"geography": "Huainan",
		"income": 9867,
		"household": 14862.4,
		"growth": 9.6
	},
	{
		"geography": "Luoyang",
		"income": 9187.9,
		"household": 15321.6,
		"growth": 8.9
	},
	{
		"geography": "Jilin",
		"income": 8444.5,
		"household": 11501.7,
		"growth": 7.7
	},
	{
		"geography": "Anshan",
		"income": 7544.5,
		"household": 13334,
		"growth": 7
	},
	{
		"geography": "Datong",
		"income": 7449.9,
		"household": 11380.7,
		"growth": 6.4
	},
	{
		"geography": "Liuzhou",
		"income": 7403.1,
		"household": 12998,
		"growth": 10.3
	},
	{
		"geography": "Fushun",
		"income": 7059.2,
		"household": 12262.9,
		"growth": 7
	},
	{
		"geography": "Qiqihar",
		"income": 6480.9,
		"household": 11618.4,
		"growth": 7.6
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/services/data/china-cities.json
// module id = 120
// module chunks = 0